import { render, staticRenderFns } from "./InvitationRequest.vue?vue&type=template&id=4c55d6d6&"
import script from "./InvitationRequest.vue?vue&type=script&lang=js&"
export * from "./InvitationRequest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports